export default "__VITE_ASSET__CoDZD6DL__"